import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Landing from "@/pages/Landing";
import Gallery from "@/pages/Gallery";
import PlantDetail from "@/pages/PlantDetail";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <BrowserRouter>
            <ScrollManager />
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/plant/:id" element={<PlantDetail />} />
                <Route path="*" element={<Landing />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
